import type { AppContextType } from "@1js/acui-context";
import type { DeferredMenuDefinition, MenuDefinition } from "@1js/acui-menu";
import { checkExperiment, ribbonExperiments } from "@1js/acui-experiments";

export const shouldAutoOpenMenu = (
  context: AppContextType,
  menuDefinition?: MenuDefinition,
  deferredMenuDefinition?: DeferredMenuDefinition
) => {
  return (
    checkExperiment(context, ribbonExperiments.programaticMenuOpensEnabled) &&
    (
      menuDefinition ??
      (deferredMenuDefinition?.type === "DeferredOverflowMenuDefinition"
        ? deferredMenuDefinition.overflowMenuDefinition
        : deferredMenuDefinition)
    )?.shouldAutoOpen
  );
};
